import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default, { withTheme } from 'styled-components';
import themes from '../../../theming/themes.js';
import React, { memo } from 'react';
import useTabButton from '../hooks/useTabButton.js';

var _templateObject;
var StyledTabButton = styled__default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  top: 1px;\n  z-index: 1;\n  margin-top: 0;\n  flex-grow: ", ";\n\n  ", "\n\n  ", " \n  \n  \n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  \n  transition: background-color 0.3s ease, border-bottom 0.3s ease, padding-bottom 0.3s ease;\n  font-size: ", ";\n  font-weight: ", ";\n  font-family: inherit;\n  color: ", ";\n\n  ", "\n  padding: 0.75rem 1rem;\n  width: 100%;\n  &:hover {\n    text-decoration: ", ";\n    cursor: pointer;\n  }\n  &:focus {\n    outline: none;\n    text-decoration: underline;\n  }\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.tabs.fullWidth === true ? '1' : 'inherit';
}, function (_ref2) {
  var tabs = _ref2.theme.tabs,
    tabType = _ref2.tabType;
  return tabs.separator && tabType === 'primary' && "\n    &:not(:last-child):after {\n      content: '';\n      position: absolute;\n      width: ".concat(tabs.separator.width, "\n      height: ").concat(tabs.separator.height, "\n      background: ").concat(tabs.separator.background, "\n      right: ").concat(tabs.separator.right, "\n      bottom: ").concat(tabs.separator.bottom, "\n    }");
}, function (_ref3) {
  var isActive = _ref3.isActive,
    theme = _ref3.theme,
    tabType = _ref3.tabType;
  return tabType === 'primary' && "background-color: ".concat(isActive ? theme.tabs.backgroundActive : theme.tabs.background, ";} ");
}, function (_ref4) {
  var tabs = _ref4.theme.tabs,
    tabType = _ref4.tabType;
  return tabs.borderActive && tabType === 'primary' && "\n    border: ".concat(tabs.borderActive, ";\n  ");
}, function (_ref5) {
  var tabs = _ref5.theme.tabs,
    tabType = _ref5.tabType;
  return tabs.borderBottom && tabType === 'primary' && "\n    border-bottom: ".concat(tabs.borderBottom, ";\n  ");
}, function (_ref6) {
  var tabs = _ref6.theme.tabs,
    tabType = _ref6.tabType;
  return tabs.borderTop && tabType === 'primary' && "\n    border-top: ".concat(tabs.borderTop, ";\n  ");
}, function (_ref7) {
  var theme = _ref7.theme,
    tabType = _ref7.tabType,
    isActive = _ref7.isActive,
    noVertical = _ref7.noVertical;
  return tabType === 'secondary' && "\n    background: none;\n    border: none;\n    &:after {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      height: ".concat(isActive ? '5' : '1', "px;\n      background-color: ").concat(isActive ? theme.palette[theme.tabs.activeFontColor] : theme.palette.grayLight, ";\n      transition: height 0.3s ease, background-color 0.3s ease;\n      ").concat(!noVertical && "@media (max-width: 768px) {\n          width: ".concat(isActive ? '5' : '1', "px;\n          height: 100%;\n          transition: width 0.3s ease, background-color 0.3s ease;\n      }"), "\n    }\n    ").concat(!noVertical && "@media (max-width: 768px) {\n      text-align: left;\n      padding-left: 1rem;\n    }", "\n   \n  ");
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSize.medium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.tabs.fontWeight;
}, function (_ref10) {
  var isActive = _ref10.isActive,
    theme = _ref10.theme;
  return isActive ? theme.palette[theme.tabs.activeFontColor] : theme.palette[theme.tabs.defaultFontColor];
}, function (_ref11) {
  var tabs = _ref11.theme.tabs;
  return tabs.marginRight && "\n      margin-right: ".concat(tabs.marginRight, ";\n  ");
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.tabs.hoverStyle;
}, function (_ref13) {
  var noVertical = _ref13.noVertical,
    tabType = _ref13.tabType,
    theme = _ref13.theme;
  return !noVertical && tabType === 'primary' && "\n    @media (max-width: 768px) {\n\n    margin: .2rem 0 .2rem 0;\n    text-align: left;\n    border: ".concat(theme.tabs.mobileBorder, ";\n\n    ").concat(theme.tabs.separator && "\n      &:not(:last-child):after {\n        display: none;\n      }", "\n  }\n    ");
});
var TabButton = function TabButton(_ref14) {
  var label = _ref14.label,
    name = _ref14.name,
    _ref14$theme = _ref14.theme,
    theme = _ref14$theme === void 0 ? themes["default"] : _ref14$theme,
    onClick = _ref14.onClick;
  var _useTabButton = useTabButton(name),
    activate = _useTabButton.activate,
    isActive = _useTabButton.isActive,
    render = _useTabButton.render,
    tabType = _useTabButton.tabType,
    noVertical = _useTabButton.noVertical;
  var activateAndOnClick = function activateAndOnClick(event) {
    activate();
    if (onClick) {
      onClick(event);
    }
  };
  var ariaLabelName = name.toLocaleLowerCase().replace(/\s+/g, '-');
  return render(/*#__PURE__*/React.createElement(StyledTabButton, {
    theme: theme,
    type: "button",
    role: "tab",
    tabIndex: isActive ? 0 : -1,
    "aria-controls": "".concat(ariaLabelName, "-tab-panel"),
    "aria-selected": isActive,
    id: "".concat(ariaLabelName, "-tab-button"),
    onClick: activateAndOnClick,
    isActive: isActive,
    tabType: tabType,
    noVertical: noVertical,
    onKeyDown: function onKeyDown(e) {
      var target = e.currentTarget;
      var activeTab;
      if (e.key == 'ArrowLeft') {
        var _target$parentNode, _activeTab$firstChild;
        activeTab = target.previousElementSibling || ((_target$parentNode = target.parentNode) === null || _target$parentNode === void 0 ? void 0 : _target$parentNode.lastElementChild);
        activeTab && ((_activeTab$firstChild = activeTab.firstChild) === null || _activeTab$firstChild === void 0 || (_activeTab$firstChild = _activeTab$firstChild.parentElement) === null || _activeTab$firstChild === void 0 ? void 0 : _activeTab$firstChild.focus());
      } else if (e.key == 'ArrowRight') {
        var _target$parentNode2, _activeTab$firstChild2;
        activeTab = target.nextElementSibling || ((_target$parentNode2 = target.parentNode) === null || _target$parentNode2 === void 0 ? void 0 : _target$parentNode2.firstElementChild);
        activeTab && ((_activeTab$firstChild2 = activeTab.firstChild) === null || _activeTab$firstChild2 === void 0 || (_activeTab$firstChild2 = _activeTab$firstChild2.parentElement) === null || _activeTab$firstChild2 === void 0 ? void 0 : _activeTab$firstChild2.focus());
      } else if (e.key == 'Enter' || e.key == 'Space') {
        target.click();
      }
      //activeTab && document.getElementById(activeTab.id)?.focus();
    }
  }, label || name));
};
var TabButton$1 = withTheme(/*#__PURE__*/memo(TabButton));

export default TabButton$1;
